/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.controllers {

    export interface IActivateSystemConfigurationScope extends angular.IScope {
        activate: () => void;
        activeSystemConfig: Wars.Domain.Model.Dtos.ConfigSnapshotDto;
        validationIssues: Array<string>;
    }

    export class ActivateSystemConfigurationController implements IController {
        
        constructor(private $scope: IActivateSystemConfigurationScope, private configurationCacheService: services.ConfigurationCacheService)
        {
            this.$scope.activate = () => this.activateInternal();

            this.configurationCacheService.getActiveSystemLevelConfiguration().then(
                (systemConfig) => {
                    this.$scope.activeSystemConfig = systemConfig;
                });
        }

        public activateInternal() {
            this.configurationCacheService.activateSystemLevelConfiguration().then(
                (systemConfig) => {
                    this.$scope.activeSystemConfig = systemConfig;
                });
        }
    }
}

warsApp.registerController('ActivateSystemConfigurationController', ['$scope', 'configurationCacheService']);